/* RESPONSIBLE TEAM: team-phone */
import Route from '@ember/routing/route';

export default class AmazonConnectCti extends Route {}
